import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
// ------ Services ------ //
import * as clientManagementService from '../../services/clientManagementService'
import * as eventManagementService from '../../services/eventManagementService'
import * as clientEventService from '../../services/clientEventService'
import * as leadCaptureService from '../../services/leadCaptureService'
import * as badgeService from '../../services/badgeManagementService'
// ------ Styles ------ //
import styles from './LeadCaptureHeader.module.css'
const LOCAL_STORAGE_KEY = "headerentries"
const LeadCaptureHeader = ({ user, continueButtonVisibility }) => {
    const [formData, setFormData] = useState(
        {
            clientName: null,
			clientId: null,
            client: {},
            event: {},
			eventId: null,
            eventName: null,
            useFlatSetup: null,
			leadCapture: {},
            leadCaptureName: null,
            leadCaptureId: null,
        }
    )
    // State    
    const [clientOptions, setClientOptions] = useState([])
    const [eventOptions, setEventOptions] = useState([])
    const [leadCaptureOptions, setLeadCaptureOptions] = useState([])
    const [clientEventInfo, setClientEventInfo] = useState({})
    const [showReload, setShowReload] = useState(false)
    const [showContinueButton, setShowContinueButton] = useState(false)
    const [pullFlatTemplateSetup, setPullFlatTemplateSetup] = useState(false)

    const createEventsRequestBody = async () => {
        let requestBody = {}

        if (formData.client && formData.client.clientId) {
            requestBody =
            {
                clientId: formData.client.clientId,
                clientName: formData.client.clientName,
            }
        }

        return await requestBody;
    }
    const createFlatTemplateSetupRequestBody = async () => {

        let requestBody = {}

        if (formData.client && formData.client.clientId &&
            formData.event && formData.event.eventId) {
            requestBody =
            {
                clientId: formData.client.clientId,
                eventId: formData.event.eventId,
            }
        }

        return await requestBody;
    }
	const fetchLeadCaptures = async () => {
        if (formData.clientName && formData.client) {
            try {
                const leadCaptures = await leadCaptureService.getEventsByClient(formData.client.clientId);
                if (leadCaptures && leadCaptures.length > 0) {
                    setLeadCaptureOptions(leadCaptures);

                }
                else {
                    setLeadCaptureOptions([]);
                }
            } catch /*(err)*/ {
                setLeadCaptureOptions([]);
            }
            
        }

    }

    const fetchEvents = async () => {
        if (formData.clientId && formData.client) {
            let oldInfo = localStorage.getItem(LOCAL_STORAGE_KEY)
            if (oldInfo && oldInfo !== undefined) {
                oldInfo = JSON.parse(oldInfo);
            }
            if (oldInfo && oldInfo !== undefined && oldInfo.events && oldInfo.events !== undefined) {
                setEventOptions(oldInfo.events);
            }
            else {
                let req = await createEventsRequestBody();
                const events = await eventManagementService.loadEvents(req);
                if (events && events.length > 0) {
                    setEventOptions(events);
                    let clientEvents = { 'clients': clientOptions, 'events': events }
                    if (oldInfo && oldInfo !== undefined) {
                        localStorage.removeItem(LOCAL_STORAGE_KEY);
                    }
                    // To Set Data (Up to 5MB)
                    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(clientEvents));
                }
                else {
                    setShowReload(true)
                    setEventOptions(null);
                    setFlatSetupInfo(false);
                }
            }
        }
    }
    const fetchFlatTemplateSetup = async () => {
        if (formData.client && formData.event) {
            let req = await createFlatTemplateSetupRequestBody();
            const flatSetup = await badgeService.getFlatSetupCheck(req);
            if (flatSetup) {
                const newClientEvent = {
                    clientId: formData.client.clientId,
                    eventId: formData.event.eventId,
                    clientName: formData.client.clientName,
                    eventName: formData.event.name,
                    useFlatSetup: flatSetup,
                }
                setFormData({
                    ...formData,
                    useFlatSetup: flatSetup,
                })
                clientEventService.setClientEvent(newClientEvent)
            }
            else {
                const newClientEvent = {
                    clientId: formData.client.clientId,
                    eventId: formData.event.eventId,
                    clientName: formData.client.clientName,
                    eventName: formData.event.name,
                    useFlatSetup: false,
                }
                clientEventService.setClientEvent(newClientEvent)
            }
        }
    }

    const fetchClients = async () => {
        let oldInfo = localStorage.getItem(LOCAL_STORAGE_KEY)
        if (oldInfo && oldInfo !== undefined) {
            oldInfo = JSON.parse(oldInfo);
        }
        if (oldInfo && oldInfo !== undefined && oldInfo.clients && oldInfo.clients !== undefined) {
            setClientOptions(oldInfo.clients);
        }
        else {
            const clients = await clientManagementService.getClients();
            setClientOptions(clients);
            let clientEvents = { 'clients': clients, 'events': null }
            // To Set Data (Up to 5MB)
            localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(clientEvents));
        }
    }

    useEffect(() => {
        // pull events and lead capture events, if clients is populated and selected
        if (formData.clientId && formData.client) {
            setEventOptions([])
            const newClientEvent = {
                clientId: formData.client.clientId,
                clientName: formData.client.clientName,
				eventId: user && user.EventId !== undefined ? user.EventId : clientEventInfo && clientEventInfo.eventId !== undefined ? clientEventInfo.eventId : null,
                eventName: clientEventInfo && clientEventInfo.eventName !== undefined ? clientEventInfo.eventName : null,
            }
            clientEventService.setClientEvent(newClientEvent)
            setClientEventInfo(newClientEvent)
            fetchEvents();
			setLeadCaptureOptions([]);
            fetchLeadCaptures();
        }
    }, [formData.clientId])

    useEffect(() => {
        if (clientOptions && clientOptions.length > 0 && clientEventInfo && clientEventInfo.clientId) {
            setClientInfo(clientEventInfo.clientId)
        }
    }, [clientOptions])
    useEffect(() => {
        if (formData.client && formData.client !== undefined && formData.event && formData.event !== undefined && pullFlatTemplateSetup) {
            fetchFlatTemplateSetup()
        }
    }, [pullFlatTemplateSetup])

    useEffect(() => {
        // restore saved event selection only when loading events for the same client that was previously saved
        if (
            eventOptions && eventOptions.length > 0 &&
            clientEventInfo && clientEventInfo.eventId &&
            clientEventInfo.clientId === formData.client?.clientId
        ) {
            setEventInfo(clientEventInfo.eventId)
            setShowContinueButton(true)
        }
    }, [eventOptions])
    useEffect(() => {
        //set selections to the saved values
        if (leadCaptureOptions && leadCaptureOptions.length > 0 && clientEventInfo && clientEventInfo.refNumber) {
            setLeadCaptureInfo(clientEventInfo.refNumber)
        }
    }, [leadCaptureOptions])

    useEffect(() => {
        // check if entry is stored
        // store into local object
        let localclientevent = clientEventService.getClientEvent()
        if (localclientevent) {
            setClientEventInfo(localclientevent)
            if (continueButtonVisibility) {
                setShowContinueButton(true)
			} 
        }
        else if (user && user.ClientId && user.EventId && user.Role !== "SuperAdmin") {
            const newClientEvent = {
                clientId: user.ClientId,
                eventId: user.EventId,
            }
            setClientEventInfo(newClientEvent)
        }
        // pull clients
        fetchClients();
    }, [])

    const setClientInfo = (clientId) => {
        let foundClient = clientOptions.find((item) => item.clientId === clientId);
        if (foundClient) {
            setFormData({
                ...formData,
                clientName: foundClient.clientName,
                client: foundClient,
                event: {},
                eventName: null,
                useFlatSetup: null
            })
        }
        else {
            setFormData({
                ...formData,
                clientName: null,
                client: null,
                event: {},
                eventName: null,
                useFlatSetup: null
            })
        }
    }

    const handleChangeClient = (e) => {
        if (e.target.type === 'select-one') {
            localStorage.removeItem(LOCAL_STORAGE_KEY);
            setShowContinueButton(false)
            setEventOptions([])
            setPullFlatTemplateSetup(false)
            setClientInfo(e.target.value)
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }

    const setEventInfo = (eventId) => {
        let foundEvent = eventOptions.find((item) => item.eventId === eventId);
        if (foundEvent) {
            setFormData({
                ...formData,
                eventName: foundEvent.name,
                event: foundEvent,
                useFlatSetup: clientEventInfo.useFlatSetup,

            })

        }
        else {
            setFormData({
                ...formData,
                eventName: null,
                event: {},
                useFlatSetup: null,
            })
        }
    }
    const setFlatSetupInfo = (flatsetup) => {
        if (flatsetup) {
            setFormData({
                ...formData,
                useFlatSetup: flatsetup,
            })
        }
        else {
            setFormData({
                ...formData,
                useFlatSetup: null,
            })
        }
    }
    const setLeadCaptureInfo = (leadCaptureId) => { 
        let foundLeadCapture = leadCaptureOptions.find((item) => item.refNumber === leadCaptureId);
        if (foundLeadCapture) {
            //updating React state you must create shallow copies of all state (and nested state) that you are updating.
            setFormData({
                ...formData,
                leadCaptureName: foundLeadCapture.overwriteName,
                leadCapture: foundLeadCapture,
                leadCaptureId: foundLeadCapture.refNumber,
            })
        }
        else {
            setFormData({
                ...formData,
                leadCaptureName: null,
                leadCapture: {},
                leadCaptureId: null,
            })
        }

    }
    const trimEventName = name => {
        const charCutoff = 50
        const trimmed = name.substring(0, charCutoff) + "..."

        if (name.length <= charCutoff) return name
        return trimmed
    }
    const handleChangeEvent = (e) => {
        if (e.target.type === 'select-one') {
            const selectedEventId = e.target.value
            const foundEvent = eventOptions.find((item) => String(item.eventId) === selectedEventId)
            if (foundEvent && formData.client && formData.client.clientId) {
                const newClientEvent = {
                    clientId: formData.client.clientId,
                    eventId: foundEvent.eventId,
                    clientName: formData.client.clientName,
                    eventName: foundEvent.name,
                    leadCapture: formData.leadCapture,
                    leadCaptureId: formData.leadCapture.id,
                    leadCaptureName: formData.leadCapture.overwriteName,
                }
                setFormData({
                    ...formData,
                    eventName: foundEvent.name,
                    event: foundEvent,
                    eventId: foundEvent.eventId,
                })
                clientEventService.setClientEvent(newClientEvent)
                setClientEventInfo(newClientEvent)
                setShowContinueButton(true)
                setPullFlatTemplateSetup(true)
            } else {
                setFormData({
                    ...formData,
                    eventName: null,
                    event: {},
                    eventId: null,
                })
                setShowContinueButton(false)
            }
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }
	const handleChangeLeadCapture = (e) => {
        if (e.target.type === 'select-one') {
            const selectedleadCaptureId = e.target.value
            const foundLeadCapture = leadCaptureOptions.find((item) => String(item.refNumber) === selectedleadCaptureId)
            if (foundLeadCapture && formData.client && formData.client.clientId) {
                const newClientEvent = {
                    clientId: formData.client.clientId,
                    eventId: formData.event.eventId,
                    clientName: formData.client.clientName,
                    eventName: formData.event.name,
                    leadCapture: foundLeadCapture.leadCapture,
                    leadCaptureId: foundLeadCapture.refNumber,
                    leadCaptureName: foundLeadCapture.overwriteName,
                }
                setFormData({
                    ...formData,
                    leadCapture: foundLeadCapture.leadCapture,
                    leadCaptureId: foundLeadCapture.refNumber,
                    leadCaptureName: foundLeadCapture.overwriteName,
                })
                clientEventService.setClientEvent(newClientEvent)
                setClientEventInfo(newClientEvent)
                setShowContinueButton(true)
                setPullFlatTemplateSetup(true)
            } else {
                setFormData({
                    ...formData,
                    eventName: null,
                    event: {},
                    eventId: null,
                    leadCapture: null,
                    leadCaptureId: null,
                    leadCaptureName: null,
                })
                setShowContinueButton(false)
            }
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }

    return (
        <div>

            <div className={styles.headerContainer}>
                {!continueButtonVisibility &&
                    <div className={styles.leftPane}>
                         <b>Select Client, Event, and Lead Capture:</b>
                    </div>
                }

                <div className={styles.middlePane}>
                    Client: <br />
                    {
                        clientOptions && clientOptions.length > 1 ?
                            <select
                                name="clientName"
                                value={formData.clientName}
                                onChange={handleChangeClient}
                                key={formData.clientName}
                            >
                                <option disabled={true} value="" selected="selected">
                                    -- Select an option --
                                </option>
                                {
                                    clientOptions.map((ci, idx) => (
                                        <option key={idx}>{ci.clientName}</option>
                                    ))
                                }
                            </select>
                            :
                            <></>
                    }
                </div>

                <div className={styles.middlePane}>
                    Event:
                    <br />
                    {
                        formData.clientName && formData.client && eventOptions && eventOptions.length > 0 ?
                            <select
                                name="eventId"
                                value={formData.event && formData.event.eventId ? formData.event.eventId : ''}
                                onChange={handleChangeEvent}
                                key={formData.event && formData.event.eventId}
                            >
                                <option disabled={true} value="" selected="selected">
                                    -- Select an option --
                                </option>
                                {
                                    eventOptions.map((ci, idx) => (
                                        <option key={idx} value={ci.eventId}>{trimEventName(ci.name)}</option>
                                    ))
                                }
                            </select>
                            :
                            <>
                                {
                                    showReload ?
                                        <div>
                                            <label>No Events found (
                                                <Link to={`/ClientLoad/${formData.client.clientId}`}>Load Events...)</Link>
                                            </label>
                                        </div>
                                        :
                                        <></>
                                }
                            </>
                    }
                </div>
				<div className={styles.middlePane}>
                    Lead Capture:
                    <br />
                    {
                        formData.clientName && formData.client && leadCaptureOptions && leadCaptureOptions.length > 0 ?
                            <select
                             name="leadCaptureId"
                                value={formData.leadCapture && formData.leadCapture.refNumber ? formData.leadCapture.refNumber : ''}
                                onChange={handleChangeLeadCapture}
                                key={formData.leadCapture && formData.leadCapture.refNumber}
                            >
                                <option disabled={true} value="" selected="selected">
                                    -- Select an option --
                                </option>
                                {
                                    leadCaptureOptions.map((ci, idx) => (
                                        <option key={idx} value={ci.refNumber}>{trimEventName(ci.overwriteName)}</option>
                                    ))
                                }
                            </select>
                            :
                            <>
                                <div>
                                    <label>No Lead Captures found (
                                        <Link to={`/LeadCaptureList`}>Lead Capture Setup...)</Link>
                                    </label>
                                </div>
                            </>
                    }
                </div>

                {showContinueButton &&
                    <div className={styles.rightPane}>
                        <br />
                        <button id={styles.continueButton}>
                            <Link
                                to={`/EventSpecificStatusPage/${decodeURIComponent(clientEventInfo.eventName).trim().replace(/ /g, '-')}`}
                                state={clientEventInfo}
                                id={styles.continueLink}
                            >
                                Continue Setup
                            </Link>
                        </button>
                    </div>
                }
            </div>

            {showContinueButton && !continueButtonVisibility &&
                <>
                    <br /><hr />
                </>
            }
        </div>
    );
}

LeadCaptureHeader.defaultProps = {
    continueButtonVisibility: false,
}

export default LeadCaptureHeader;